var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:no-console
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectCoopIsSearchNotFound, selectCoopLevelFromXp, selectCoopSearchSelectedCoop, selectCoopSelectedLanguage, selectJoinableCoops, } from "../../selectors/selectCoopInfo";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { utilNumber } from "../../utils/utilNumber";
import { SearchInput } from "../generic/search-input/SearchInput";
import { Table } from "../generic/table/Table";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionCoopClearSelectedCoop, actionCoopJoinableCoopList, actionCoopSearchRequest, actionJoinableCoopSelect, } from "./actionCoop";
import { CoopSearchLanguageFilter } from "./CoopSearchLanguageFilter";
import { CoopSearchTableRow } from "./CoopSearchTableRow";
import { CoopInfo } from "./info-view/CoopInfo";
import { CoopMember } from "./info-view/CoopMember";
var TabCoopSearchDOM = /** @class */ (function (_super) {
    __extends(TabCoopSearchDOM, _super);
    function TabCoopSearchDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.CoopSearchTableHeaders = [
            utilLoca.get(IdLoca.rankingMenu_level),
            utilLoca.get(IdLoca.rankingMenu_name),
            utilLoca.get(IdLoca.members),
            utilLoca.get(IdLoca.status),
        ];
        _this.getTableHeader = function () {
            var headers = [];
            _this.CoopSearchTableHeaders.map(function (head, index) {
                headers.push(React.createElement(React.Fragment, { key: "th-" + index },
                    React.createElement("div", { className: "td" }, head),
                    index + 1 < _this.CoopSearchTableHeaders.length && (React.createElement("div", { className: "td__divider" }))));
            });
            return headers;
        };
        _this.getTableRows = function () {
            var _a = _this.props, joinableCoops = _a.joinableCoops, onCoopClick = _a.onCoopClick;
            var rows = [];
            joinableCoops.forEach(function (coop) {
                var id = coop.id, xp = coop.xp, memberCount = coop.memberCount, memberLimit = coop.memberLimit, name = coop.name;
                var level = selectCoopLevelFromXp(xp || Long.ZERO);
                rows.push(React.createElement(CoopSearchTableRow, { id: id, name: name, level: level, memberCount: memberCount, memberLimit: memberLimit, key: utilNumber.format(id), onClick: function () { return onCoopClick(coop); } }));
            });
            return rows;
        };
        _this.onSearchClick = function (searchText) {
            var _a = _this.props, searchCoop = _a.searchCoop, playerId = _a.playerId;
            searchCoop(searchText, playerId);
        };
        return _this;
    }
    TabCoopSearchDOM.prototype.componentWillUnmount = function () {
        var _a = this.props, selectedCoop = _a.selectedCoop, clearSelectedCoop = _a.clearSelectedCoop;
        if (selectedCoop) {
            clearSelectedCoop();
        }
    };
    TabCoopSearchDOM.prototype.componentWillMount = function () {
        var _a = this.props, playerId = _a.playerId, getJoinableCoopList = _a.getJoinableCoopList, selectedFilterLanguage = _a.selectedFilterLanguage;
        getJoinableCoopList(playerId, selectedFilterLanguage.languageCode, undefined);
    };
    TabCoopSearchDOM.prototype.render = function () {
        var selectedCoop = this.props.selectedCoop;
        if (selectedCoop) {
            return (React.createElement("div", { className: "w100 h100 flex flex--stacked flex--aligned flex--spaced flex--around" },
                React.createElement(CoopInfo, null),
                React.createElement(CoopMember, null)));
        }
        var _a = this.props, onFilterMenuClick = _a.onFilterMenuClick, selectedFilterLanguage = _a.selectedFilterLanguage, isSearchNotFound = _a.isSearchNotFound, resolveSearchNotFound = _a.resolveSearchNotFound;
        var tableHeaders = this.getTableHeader();
        var tableRows = this.getTableRows();
        return (React.createElement("div", { className: "w100 h100 flex flex--stacked " + IdStyles.TextNormal + " coop-search__tab" },
            React.createElement("div", { className: "flex flex--row__reverse " },
                React.createElement("div", { className: "flex flex--stacked flex--aligned coop-search" },
                    React.createElement(SearchInput, { onClick: this.onSearchClick, inputTextPlaceholderLoca: IdLoca.searchCoop_desc, onResolveSearchNotFound: resolveSearchNotFound, isSearchNotFound: isSearchNotFound }),
                    isSearchNotFound && (React.createElement("div", { className: "coop-search-not-found" },
                        React.createElement(TextLoca, { id: IdLoca.floatingText_coopNotFound, className: IdStyles.TextNegative })))),
                React.createElement(CoopSearchLanguageFilter, { onFilterMenuClick: onFilterMenuClick, languageIcon: selectedFilterLanguage.assetName })),
            React.createElement("div", { className: "flex flex--around v-padding__small" },
                React.createElement(Table, { headers: tableHeaders, rows: tableRows, tableContainerClassName: IdStyles.CoopListContainer + " coop-search-list-container flex--guts" }))));
    };
    return TabCoopSearchDOM;
}(React.Component));
export { TabCoopSearchDOM };
var mapState = function (state) { return ({
    isSearchNotFound: selectCoopIsSearchNotFound(state),
    joinableCoops: selectJoinableCoops(state),
    playerId: selectPlayerInfo(state).playerId,
    selectedCoop: selectCoopSearchSelectedCoop(state),
    selectedFilterLanguage: selectCoopSelectedLanguage(state),
}); };
var mapDispatch = function (dispatch) { return ({
    clearSelectedCoop: function () { return dispatch(actionCoopClearSelectedCoop()); },
    getJoinableCoopList: function (playerId, language, joinPolicy) {
        return dispatch(actionCoopJoinableCoopList({ playerId: playerId, language: language, joinPolicy: joinPolicy }));
    },
    onCoopClick: function (coop) { return dispatch(actionJoinableCoopSelect(coop)); },
    onFilterMenuClick: function () { return dispatch(actionModalOpen(IdModal.CoopLanguageFilter)); },
    resolveSearchNotFound: function () { return dispatch(actionCoopClearSelectedCoop()); },
    searchCoop: function (name, playerId) {
        return dispatch(actionCoopSearchRequest({ playerId: playerId, name: name }));
    },
}); };
export var TabCoopSearch = connect(mapState, mapDispatch)(TabCoopSearchDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/TabCoopSearch.tsx
// module id = 2622
// module chunks = 3